// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"D5-z","colorTextValue":"E5-z","swatches":"F5-z","collapseLink":"G5-z","isCollapsed":"H5-z","dropdown":"I5-z","disabled":"J5-z"};